import { ReactNode, useEffect } from "react";
import { EmptyState, Icons } from "@ir/ui";
import { useAuth, useUser } from "@/hooks";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";

const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isLoading, error, setUser } = useUser();

  useEffect(() => {
    setUser();
  }, []);

  if (isLoading || !isAuthenticated) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <EmptyState icon={Icons.Settings} title="Something went wrong" description="Please contact support" />;
  }

  return children;
};

export default UserProvider;
